import Container from './styled/Container'

const Space = Container

export default Space
